export const COLORS = ["#d95b2a", "#ba51d9", "#E63970", "#38AA49", "#4EA3C9", "#EDA128"];
